<template>
  <div>
    <TopoComponent></TopoComponent>
    <form class="form-signin">
      <div>
        <h2>Seus dados estão corretos?</h2>
        <div v-if="clinicaNaoPermiteComunicacao">
          <p class="font-weight-normal">Caso estejam incorretos, por favor, fale com o seu convênio ou com o RH da sua empresa para corrigir os dados.</p>
        </div>
        <div v-else>
          <p class="font-weight-normal">
            Mantenha os dados de contato sempre atualizados para receber informações sobre suas consultas.
          </p>
        </div>

        <span class="dados">Email: {{ emailText }}</span
        ><br />
        <br/>
        <span class="dados">Celular: {{ celularText }}</span
        ><br />
        <span class="dados">Dt Nascimento: {{ validacao.dataNascimento }}</span
        ><br />
        <!-- <span class="dados">Cartão Nacional de Saúde (CNS): {{ cnsText }}</span
        ><br /> -->
        <span class="dados">Nome da Mãe: {{ nomeMaeText }} </span
        ><br />
        <div class="clearfix"></div>

        <div v-if="clinicaNaoPermiteComunicacao">
          <button
            class="btn btn-lg btn-primary btn-block button success"
            type="button"
            @click="cadastrarSenha"
          >
            Continuar
          </button>
        </div>
        <div class="mt-4" v-else>
          <button
            class="btn btn-lg btn-primary btn-block button success"
            type="button"
            @click="validacaoDeContato"
          >
            Confirmar
          </button>
          <BtnOutlineDanger
            type="button"
            @click="atualizarDados"
          >
            Atualizar dados
          </BtnOutlineDanger>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import TopoComponent from "@/components/TopoComponent";
import BtnOutlineDanger from "@/components/BtnOutlineDanger";

export default {
  name: "VerificarDados",
  components: { TopoComponent, BtnOutlineDanger },
  data: () => ({
    validacao: {
      email: "",
      celular: "",
      dataNascimento: "",
      nomeMae:'',
      cns:'',
      flagMaeDesconhecida:''
    },
      flagPermiteEmail: null,
      flagPermiteSms: null,
  }),
  mounted() {
    this.validacao.email = sessionStorage.getItem("email");
    this.validacao.celular = sessionStorage.getItem("celular");
    this.validacao.dataNascimento = sessionStorage.getItem("dataNascimento");
    this.validacao.cns = sessionStorage.getItem("cns");
    this.validacao.nomeMae = sessionStorage.getItem("nomeMae");
    this.flagPermiteEmail = JSON.parse(sessionStorage.getItem("flagPermiteEmail"));
    this.flagPermiteSms = JSON.parse(sessionStorage.getItem("flagPermiteSms"));
    this.flagMaeDesconhecida = JSON.parse(sessionStorage.getItem("flagMaeDesconhecida"));
    if (!this.hasEmail) {
      this.$notify({
        group: 'mensagens',
        type: 'error',
        text: 'E-mail não foi cadastrado. Atualize seus dados.'
      })
      this.atualizarDados()
    }
  },
  computed: {
    clinicaNaoPermiteComunicacao() {
      return !this.flagPermiteEmail && !this.flagPermiteSms;
    },
    hasEmail() {
      return this.validacao.email !== 'null'
    },
    hasCelular() {
      return this.validacao.celular !== 'null'
    },
    hasNomeMae() {
      return this.validacao.nomeMae !== 'null'
    },
    hasCns(){
      return this.validacao.cns !== 'null'
    },
    emailText() {
      return this.hasEmail ? this.validacao.email: 'Não informado'
    },
    celularText() {
      return this.hasCelular ? this.validacao.celular:  'Não informado'
    },
    cnsText() {
      return this.hasCns ? this.validacao.cns:  'Não informado'
    },
    nomeMaeText() {
      if(this.flagMaeDesconhecida){
      return 'Mãe desconhecida'
      }else if(this.hasNomeMae){
      return this.validacao.nomeMae
      }else return 'Não informado'
    },
  },
  methods: {
    validacaoDeContato() {
      this.$router.push("/selecionar-metodo-de-validacao-da-conta/titular");
    },
    atualizarDados() {
      this.$router.push("/atualizar-dados/titular");
    },
    cadastrarSenha() {
      this.$router.push("/cadastrar-senha/titular");
    },
  },
};
</script>

<style scoped>
.form-signin {
  text-align: center;
}
.dados {
  color: darkgray;
  font-weight: bold;
  margin-top: 5px;
  line-height: 3.7;
}
</style>
